import Api from "@/api/api";

export default class UserApi extends Api {
  async me() {
    return this.axios.get(`/users/me`).then((response) => {
      return response.data;
    });
  }

  async getUsers(page = 1) {
    return this.axios.get(`/users/?page=${page}`).then((response) => {
      return response.data;
    });
  }

  async getUser(userId) {
    return this.axios.get(`/users/${userId}`).then((response) => {
      return response.data;
    });
  }

  async inviteUser(trip_id, email, name, role) {
    const payload = { trip_id };
    if (email) payload.email = email;
    if (name) payload.name = name;
    if (role) payload.role = role;
    return this.axios.post(`/users/invite`, payload).then((response) => {
      return response.data;
    });
  }

  async updatePlaceholderGuest(placeholderId, data) {
    return this.axios.patch(`/users/placeholder-guests/${placeholderId}`, data).then((response) => {
      return response.data;
    });
  }

  async update(user) {
    return this.axios.put(`/users/me`, user).then((response) => {
      return response.data;
    });
  }

  async stripeSession(data) {
    return this.axios.post(`/users/stripe/session`, data).then((response) => {
      return response.data;
    });
  }

  async stripePortal(data) {
    return this.axios.post(`/users/stripe/portal`, data).then((response) => {
      return response.data;
    });
  }

  async feedback(data) {
    return this.axios.post(`/users/feedback`, data).then((response) => {
      return response.data;
    });
  }

  async deleteAccount() {
    return this.axios.delete(`/users/me`).then((response) => {
      return response.data;
    });
  }
}
